import { NodeClass, ObjectClass } from '@app/types';

export const nodesForExclusion = new Set<NodeClass>([
  ObjectClass.begin,
  ObjectClass.exit,
  ObjectClass.note
]);
